export default "__VITE_ASSET__BQkjaWV2__"